import { singleItemDefaultConfig } from '../singleitemdisplay/SingleItemDisplay'
import * as H from 'history';

export default (history: H.History) => ({
    ...singleItemDefaultConfig,
    header: 'Image',
})